import { EXPORT_STATUS_HEIGHT } from 'helpers/globals'
import contextMenu from 'helpers/styles/contextMenu'

export default {
  ...contextMenu,
  topMapButtonsContainer: {
    position: 'absolute',
    width: '100%',
    top: 0,
    zIndex: 10
  },
  bottomMapButtonsContainer: {
    position: 'absolute',
    width: '100%',
    bottom: ({ exporting }) => exporting ? EXPORT_STATUS_HEIGHT : 0,
    zIndex: 10
  }
}



// WEBPACK FOOTER //
// ./src/components/MapComponents/style.js